import { useToast } from "@/ds";
import { alterarSituacaoEscopoPadrao } from "@/modules/financeiro-configuracoes";
import { useChaveIdempotencia } from "@/shared/hooks";
import { ESCOPOS_PADRAO_TOASTS, rotuloVersao } from "../../escopos-padrao.constants";
import {
  EFEITOS_TITULO,
  SITUACAO_INATIVA,
  TEXTOS,
  registro,
} from "./inativar-ativar-escopo-padrao.constants";
import type {
  InativarAtivarEscopoPadraoProps,
  InativarAtivarEscopoPadraoViewModel,
} from "./types-inativar-ativar-escopo-padrao";

export function useInativarAtivarEscopoPadrao({
  escopo,
  versao,
  onClose,
  onConcluido,
}: InativarAtivarEscopoPadraoProps): InativarAtivarEscopoPadraoViewModel {
  const toast = useToast();
  const { comChave } = useChaveIdempotencia();
  const textos = TEXTOS;
  const versaoRotulo = rotuloVersao(versao);
  const nome = escopo.equipamento?.tag || escopo.escopo;
  const equipamento = escopo.equipamento
    ? [escopo.equipamento.fabricante, escopo.equipamento.modelo].filter(Boolean).join(" ")
    : null;

  return {
    acao: "inativar",
    titulo: textos.titulo,
    subtitulo: textos.subtitulo,
    confirmLabel: textos.confirmar,
    tituloEfeitos: EFEITOS_TITULO,
    oQueAcontece: textos.efeitos(versaoRotulo),
    identificacao: {
      intro: textos.intro,
      nome,
      detalhe: registro([escopo.embarcacao?.nome, equipamento], versaoRotulo),
      tag: escopo.grupo?.nome ?? null,
    },
    onConfirmar: async () => {
      await comChave({ id: escopo.id, situacao: SITUACAO_INATIVA }, (idempotencyKey) =>
        alterarSituacaoEscopoPadrao(escopo.id, SITUACAO_INATIVA, { idempotencyKey }),
      );
      toast.success(ESCOPOS_PADRAO_TOASTS.situacao.inativar(nome));
      onConcluido();
    },
    onCancelar: onClose,
  };
}
